import type { SessionLapTimingOverlay } from '@kangaroo/shared';

export function utcIsoToSessionTimecodeMs(
  overlay: SessionLapTimingOverlay | null | undefined,
  utcIso: string | null | undefined,
) {
  if (!overlay || !utcIso) {
    return null;
  }

  const utcMs = Date.parse(utcIso);
  if (!Number.isFinite(utcMs)) {
    return null;
  }

  if (overlay.anchorMs != null) {
    return utcMs - overlay.anchorMs;
  }

  const laps = [...overlay.rawLaps, ...(overlay.circuitLapSet?.laps ?? [])];
  const containing = laps.find((lap) => {
    if (!lap.utcStartIso || !lap.utcEndIso) {
      return false;
    }

    const startUtcMs = Date.parse(lap.utcStartIso);
    const endUtcMs = Date.parse(lap.utcEndIso);
    return (
      Number.isFinite(startUtcMs) &&
      Number.isFinite(endUtcMs) &&
      utcMs >= startUtcMs &&
      utcMs <= endUtcMs
    );
  });

  if (!containing?.utcStartIso || !containing.utcEndIso || containing.endMs <= containing.startMs) {
    return null;
  }

  const startUtcMs = Date.parse(containing.utcStartIso);
  const endUtcMs = Date.parse(containing.utcEndIso);
  if (!Number.isFinite(startUtcMs) || !Number.isFinite(endUtcMs) || endUtcMs <= startUtcMs) {
    return null;
  }

  const fraction = (utcMs - startUtcMs) / (endUtcMs - startUtcMs);
  return containing.startMs + (containing.endMs - containing.startMs) * fraction;
}

export function sessionTimecodeMsToUtcIso(
  overlay: SessionLapTimingOverlay | null | undefined,
  timecodeMs: number,
) {
  if (!overlay || !Number.isFinite(timecodeMs)) {
    return null;
  }

  if (overlay.anchorMs != null) {
    return new Date(overlay.anchorMs + timecodeMs).toISOString();
  }

  const laps = [...overlay.rawLaps, ...(overlay.circuitLapSet?.laps ?? [])];
  const containing = laps.find(
    (lap) =>
      timecodeMs >= lap.startMs && timecodeMs <= lap.endMs && lap.utcStartIso && lap.utcEndIso,
  );
  if (!containing?.utcStartIso || !containing.utcEndIso || containing.endMs <= containing.startMs) {
    return null;
  }

  const startUtcMs = Date.parse(containing.utcStartIso);
  const endUtcMs = Date.parse(containing.utcEndIso);
  if (!Number.isFinite(startUtcMs) || !Number.isFinite(endUtcMs) || endUtcMs <= startUtcMs) {
    return null;
  }

  const fraction = (timecodeMs - containing.startMs) / (containing.endMs - containing.startMs);
  return new Date(startUtcMs + (endUtcMs - startUtcMs) * fraction).toISOString();
}

export function footageStartConfirmed(upload: {
  footageTimingSource?: string | null;
  footageStartConfirmedAt?: string | null;
}) {
  return (
    Boolean(upload.footageStartConfirmedAt) ||
    upload.footageTimingSource === 'manual-map' ||
    upload.footageTimingSource === 'gopro-telemetry'
  );
}
